import { Button, useTheme } from "@material-ui/core";
import React from "react";

import { Site } from "../../../../../dtos/site";

import { RestartBiometricDeviceButton } from "./RestartBiometricDeviceButton";
import { RestartHmiDeviceButton } from "./RestartHmiDeviceButton";
import { SensorResetButton } from "./SensorResetButton";
import { ServiceRestartButton } from "./ServiceRestartButton";
import { SystemRestartButton } from "./SystemRestartButton";

interface Props {
    site: Site;
    showDangerousButtons: boolean;
    onEnableMaintenanceMode: () => void;
}

export function DeviceActionsSection({ site, showDangerousButtons, onEnableMaintenanceMode }: Props) {
    const theme = useTheme();

    return (
        <>
            <h1 style={{ color: theme.palette.text.primary, margin: "40px 0 40px 0" }} >
                Device Actions
            </h1>

            <div
                style={{
                    gap: "10px",
                    display: "flex",
                    flexDirection: "column",
                    maxWidth: "240px",
                }}
            >
                {/* Ordered least to most disruptive. */}
                {showDangerousButtons && (
                    <>
                        <SensorResetButton site={site} />
                        <RestartBiometricDeviceButton site={site} />
                        <RestartHmiDeviceButton site={site} />
                        <ServiceRestartButton site={site} />
                        <SystemRestartButton site={site} />
                    </>
                )}
                <Button
                    color="primary"
                    variant="contained"
                    onClick={onEnableMaintenanceMode}
                >
                    Enable Maintenance Mode
                </Button>
            </div>
        </>
    );
}
